import { render, staticRenderFns } from "./campaign-edit.vue?vue&type=template&id=d4d296f4&scoped=true"
import script from "./campaign-edit.vue?vue&type=script&lang=js"
export * from "./campaign-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d296f4",
  null
  
)

export default component.exports